import { CrudService } from 'ui-shared';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ImportacaoDadosEntity } from '@catalogo/models';
import { Observable } from "rxjs";
import { CONFIGURACAO_API_URL, OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'any' })
export class ImportacaoDadosDataService extends CrudService<ImportacaoDadosEntity> {

    protected url: string;
    protected urlConfiguracao: string;
    protected urlImportarDadosPortalUnico: string;

    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        @Inject(CONFIGURACAO_API_URL) urlBaseConfiguracao: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.urlImportarDadosPortalUnico = `${urlBase}/PortalUnico`;
        this.urlConfiguracao = `${urlBaseConfiguracao}/v1/ArquivoTemplate/importacao`;
    }

    public obterTemplateOperadores = (): Observable<HttpResponse<Blob>> => {
        return this.httpClient.get(`${this.urlConfiguracao}/operador`, { observe: 'response', responseType: 'blob' });
    }

    public obterTemplateProdutos = (multiempresa: boolean): Observable<HttpResponse<Blob>> => {
        return this.httpClient.get(`${this.urlConfiguracao}/produto?multiempresa=${multiempresa}`, { observe: 'response', responseType: 'blob' });
    }
}
